import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromAuthStore from 'src/app/auth/store';
import { EMAIL_VALIDATION, MIN_LENGTH, VALIDATIONS } from 'src/utils/constants';
import { IPhoneInfo } from 'src/utils/declarations';
import { cleanTelNumber } from 'src/utils/helpers';

@Component({
  selector: 'app-registration-component',
  templateUrl: './registration-component.component.html',
  styleUrls: ['./registration-component.component.scss'],
})
export class RegistrationComponentComponent implements OnInit {
  stage: number = 1;
  showPassword1: boolean = false;
  showPassword2: boolean = false;
  agreeToRules: boolean = false;
  password_repeat: string = '';
  user_password: string = '';
  invalidDNSName: boolean = false;

  phoneInfo: IPhoneInfo = {
    code: 0,
    isInvalid: false,
    isDirty: false,
    value: '',
  };

  registrationForm1: FormGroup;
  registrationForm2: FormGroup;

  constructor(
    private fb: FormBuilder,
    private authStore: Store<fromAuthStore.State>
  ) {}

  ngOnInit(): void {
    this.registrationForm1 = this.fb.group({
      firstName: ['', [Validators.required, ...VALIDATIONS.firstName]],
      lastName: ['', [Validators.required, ...VALIDATIONS.firstName]],
      middleName: ['', [Validators.required, ...VALIDATIONS.firstName]],
    });
    this.registrationForm2 = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.minLength(MIN_LENGTH),
          Validators.pattern(EMAIL_VALIDATION),
        ],
      ],
      type: ['', [Validators.required, Validators.minLength(MIN_LENGTH)]],
    });
  }

  register() {
    this.authStore.dispatch(
      new fromAuthStore.Register({
        firstName: this.registrationForm1.get('firstName')?.value,
        middleName: this.registrationForm1.get('middleName')?.value,
        lastName: this.registrationForm1.get('lastName')?.value,
        type: this.registrationForm2.get('type')?.value,
        phone: cleanTelNumber(this.phoneInfo.value),
        email: this.registrationForm2.get('email')?.value,
        password: this.user_password,
        password_confirmation: this.password_repeat,
      })
    );
  }

  changePhoneInfo(eventData: IPhoneInfo) {
    this.phoneInfo = eventData;
  }
}
